import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { toLocalized } from 'shared/helpers/locale';
import SearchPanel from 'desktop/components/SearchPanel/SearchPanel';
import { generateDealersSearchUrl, generateSearchQuery } from 'shared/helpers/urls';
import history from 'history.js';
import s from './SearchBar.css';

class SearchBar extends React.Component {
  static propTypes = {
    transportType: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    location: PropTypes.shape(),
    //
    intl: intlShape.isRequired,
    count: PropTypes.number,
  };

  static defaultProps = {
    count: 0,
    location: null,
  };

  getSearchUrl = state => {
    const { location } = this.props;
    const pathname = generateDealersSearchUrl({ ...state, location });
    const { isNew, ...validDealersSate } = state;
    const query = generateSearchQuery(validDealersSate);

    return toLocalized(`/${pathname}?${queryString.stringify(query)}`, this.props.locale);
  };

  handleClearForm = () => {
    const pathname = generateDealersSearchUrl({
      transport: this.props.formState.transport,
      hasNew: this.props.formState.hasNew,
    });
    this.props.selectedActions.clearForm();
    history.push(toLocalized(`/${pathname}`, this.props.locale));
  };

  handleSetAge = age => {
    if (!isNaN(age.id) && age.id !== null) {
      this.props.selectedActions.set.hasNew(age.id);
      history.push(this.getSearchUrl({ ...this.props.formState, hasNew: age.id }));
    } else {
      this.props.selectedActions.set.hasNew(null);
      history.push(this.getSearchUrl({ ...this.props.formState, hasNew: null }));
    }
  };

  render() {
    const {
      transportType,
      formData,
      formVocabulary,
      selectedActions,
      formState,
      intl,
      count,
    } = this.props;

    const age = [
      {
        id: null,
        title: intl.formatMessage({ id: 'Все' }),
      },
      {
        id: 1,
        title: intl.formatMessage({ id: 'Новые' }),
      },
      {
        id: 0,
        title: intl.formatMessage({ id: 'С пробегом' }),
      },
    ];

    return (
      <SearchPanel
        setAge={this.handleSetAge}
        transportType={transportType}
        formVocabulary={formVocabulary}
        formData={formData}
        formState={formState}
        selectedActions={selectedActions}
        getSearchUrl={this.getSearchUrl}
        handleClearForm={this.handleClearForm}
        expandable={false}
        searchable={false}
        page="dealers"
        cardTypes={intl.formatMessage({ id: 'aвтосалонов' }, { count: count || 0 })}
        age={age}
      />
    );
  }
}

const mapStateToProps = ({ globals, searchForm }) => ({
  locale: globals.locale,
  location: globals.location,
  count: searchForm.data.count,
});

export default withStyles(s)(connect(mapStateToProps)(injectIntl(SearchBar)));



// WEBPACK FOOTER //
// ./src/desktop/routes/dealers/components/SearchBar/SearchBar.js